export default function SimilarPinCardCSS() {
  return `
.PinLandingCloseup__similarPin__button {
  background-color: transparent;
  border: 0;
  color: #8e8e8e;
  font-size: 12px;
  font-weight: bold;
  height: 13px;
  letter-spacing: -0.3px;
  -moz-osx-font-smoothing: grayscale;
  outline: none;
  padding: 0;
  -webkit-font-smoothing: antialiased;
}
`;
}
